/**
 * SOCIAL-LAYER D — total unread chat messages across the user's collab threads.
 *
 * Polls workspace-service /collab/threads and sums `unread_count`. Never throws
 * (a missing/pre-deploy endpoint yields 0). Used to badge the Messages entry in
 * the top bar. Kept intentionally light — a single list call on an interval.
 */
import { useEffect, useState } from 'react'
import { listThreads } from '@/lib/api/collab'

export function useCollabUnread(pollMs = 25_000): number {
  const [count, setCount] = useState(0)
  useEffect(() => {
    let alive = true
    const load = async () => {
      try {
        const threads = await listThreads()
        if (!alive) return
        setCount(threads.reduce((n, t) => n + (t.unread_count ?? 0), 0))
      } catch {
        if (alive) setCount(0)
      }
    }
    load()
    const id = setInterval(load, pollMs)
    return () => {
      alive = false
      clearInterval(id)
    }
  }, [pollMs])
  return count
}
